<ng-container *ngIf="pdfPreviewUrl">
  <pdf-viewer [src]="pdfPreviewUrl"
              [render-text]="true"
              [original-size]="false"
              style="width: 100%; height: 500px">
  </pdf-viewer>
</ng-container>
<ng-container *ngIf="!pdfPreviewUrl">
  <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
    <app-loading-spinner></app-loading-spinner>
    <p style="color: black; margin-top: 10px">We're generating the preview now</p>
  </div>
</ng-container>
